export type ConversationSource = 'workspace' | 'job_card';

export type ConversationComment = {
  id: string;
  source: ConversationSource;
  body: string;
  createdAt: string;
  updatedAt?: string | null;
  authorId: string;
  authorName: string;
  authorRole?: string | null;
  cardTitle?: string | null;
};

export function commentRoleLabel(role?: string | null, authorName?: string | null): string | null {
  const normalized = String(role || '').trim().toLowerCase();
  const label = normalized === 'admin' ? 'Admin' : normalized === 'user' ? 'User' : null;
  if (!label) return null;
  if (String(authorName || '').trim().toLowerCase() === label.toLowerCase()) return null;
  return label;
}

export function commentAuthorName(fullName?: string | null, email?: string | null): string {
  const name = String(fullName || '').trim();
  if (name) return name;
  const mail = String(email || '').trim();
  if (mail) return mail.split('@')[0];
  return 'Staff';
}

export function isOwnComment(comment: Pick<ConversationComment, 'authorId'>, userId?: string | null): boolean {
  return !!userId && comment.authorId === userId;
}

export function commentWasEdited(comment: Pick<ConversationComment, 'createdAt' | 'updatedAt'>): boolean {
  if (!comment.updatedAt) return false;
  const created = Date.parse(comment.createdAt);
  const updated = Date.parse(comment.updatedAt);
  if (!Number.isFinite(created) || !Number.isFinite(updated)) return false;
  return updated - created > 2000;
}

/** Puts a preserved note before every later comment, using the workspace start when that is earlier. */
export function seededNoteTimestamp(projectCreatedAt?: string | null, commentTimes: string[] = []): string {
  const times = commentTimes
    .map((value) => Date.parse(value))
    .filter((value) => Number.isFinite(value));
  const earliest = times.length ? Math.min(...times) : Number.NaN;
  const projectTime = Date.parse(String(projectCreatedAt || ''));
  if (Number.isFinite(projectTime) && (!Number.isFinite(earliest) || projectTime < earliest)) {
    return new Date(projectTime).toISOString();
  }
  if (Number.isFinite(earliest)) return new Date(earliest - 60_000).toISOString();
  return new Date().toISOString();
}
